import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { useQuery } from 'react-apollo'
import gql from 'graphql-tag'

import { EmailShareButton } from 'react-share'
import { Link } from 'react-router-dom'

import BottomBar from '../../components/BottomBar'
import ShareButton from '../../components/ShareButton'
import Button from '../../components/Button'

import colors from '@fe/ui/colors'

import * as ProfileReducer from '../../reducers/profile'
import { RETURN_PATH } from '../../config'

import { builder, BuilderComponent } from '@builder.io/react'

builder.init('32eea804311a4d17817f2e534ded7af8')

const builders = {
  openAccept: 'f81525b568da490b9b6eccf83a70f2ac',
  premiumAccept: '5367ed6c8b314b3182af381dbbe62e14',
  appAccept: 'de92d972c1294058affab46e0f2b701c'
}

const externalIdQuery = gql`
query($userId: String!){
  getUser(id: $userId) {
    externalId
  }
}
`
const buildShareData = ({ data }) => {
  if (!data) {
    return {}
  }

  const externalId = _.get('getUser.externalId', data)
  const title = 'Join GLFR Open!'
  const text = 'Come join me!'
  const url = `${RETURN_PATH}/open/?rf=${externalId}`
  return {
    // Common
    title,
    url,
    // Native share
    text,
    // Social
    hashtag: '#GLFROPEN',
    // Email
    subject: title,
    body: text
  }
}

const getBuilderPage = ({ open, app } = {}) => {
  if (app) {
    return builders.appAccept
  }
  if (open) {
    return builders.openAccept
  }
  return builders.premiumAccept
}

const Accept = ({ profile, history, ...props }) => {
  React.useEffect(() => {
    props.loadProfile()
  }, [])
  const shareData = buildShareData(useQuery(externalIdQuery, { variables: { userId: profile.id } }))

  const hasProfile = React.useMemo(() => {
    return !_.isEmpty(profile)
  }, [profile])

  if (!hasProfile) {
    return (
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: 24, paddingBottom: 64 }}>
        <BuilderComponent
          model='page'
          entry={getBuilderPage(_.get('location.state', history))}
        />
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: 24, paddingBottom: 64 }}>
      <BuilderComponent
        model='page'
        entry={getBuilderPage(_.get('location.state', history))}
      />

      <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
        <ShareButton
          dialogTitle='Del mit link'
          shareData={shareData}
        >
          Del mit link
        </ShareButton>
        <EmailShareButton {...shareData}>
          <Button component='p'>
            Inviter via email
          </Button>
        </EmailShareButton>
      </div>
      <BottomBar
        leftColor={colors.secondaryDarkGrey + 'C0'}
        leftText={<a style={{ color: 'inherit' }} href='glfr://'>Åben GLFR</a>}
        rightText={(
          <Link
            style={{ color: 'inherit' }}
            to={`/u/${_.get('handle', profile)}/open`}
          >
            Se overblikket
          </Link>
        )}
      />
    </div>
  )
}

export default _.compose(
  connect(
    s => {
      return {
        profile: ProfileReducer.selectors.getProfile(s)
      }
    },
    d => {
      return {
        loadProfile: () => d(ProfileReducer.actions.loadRequest(Date.now()))
      }
    }
  )
)(Accept)
